import { ActionCardsCallbacks, ActionCardsConfig, ActionCardsSettings } from '@playbooks/action-cards/types'
import { ActionCardsElement } from '@playbooks/action-cards'
import ActionCards from '@playbooks/action-cards'
import { cn } from '@playbooks/ui/lib/utils'
import { ActionCard } from '@playbooks/core/src/interfaces/ActionCard'

import useHorizontalSliderMethods from '../hooks/useHorizontalSliderMethods'
import { SliderManager } from '../types'

interface ActionCardsViewProps {
  playbookId: string
  config: ActionCardsConfig
  actionCard: ActionCard
  settings: ActionCardsSettings
  callbacks: ActionCardsCallbacks
  sliderManagerRef: React.RefObject<SliderManager | null>
  actionCardsElementRef: React.RefObject<ActionCardsElement | null>
  setIsFinishButtonVisible: (flag: boolean) => void
}

function ActionCardsView({
  config,
  settings,
  callbacks,
  actionCard,
  playbookId,
  actionCardsElementRef,
  sliderManagerRef,
  setIsFinishButtonVisible,
}: ActionCardsViewProps) {
  const scrollContainer = useHorizontalSliderMethods({
    playbookId,
    viewMode: settings.viewMode,
    sliderManagerRef: sliderManagerRef,
    setIsFinishButtonVisible,
  })

  return (
    <div
      ref={scrollContainer}
      data-role="webplay-carousel"
      className={cn(`flex h-full overflow-hidden transition-[filter]`)}
    >
      <ActionCards
        config={config}
        value={actionCard}
        settings={settings}
        ref={actionCardsElementRef}
        onChange={callbacks.onChange}
        onLastSlideVisible={callbacks.onLastSlideVisible}
      />
    </div>
  )
}

export default ActionCardsView
